/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @description
 *
 * @created at Tue Jan 17 2023
 **/

import React from "react";
import Dot from "./Dot";
import Pin from "./Pin";
import { EmotionJSX } from "@emotion/react/types/jsx-namespace";
import NewBadge from "./NewBadge";
import RecBadge from "./RecBadge";

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
	type: keyof typeof BadgeType;
}

const BadgeType: Record<string, EmotionJSX.Element> = {
	mediumDot: <Dot size="m" color="red" />,
	largeDot: <Dot size="l" color="red" />,
	xlargeDot: <Dot size="xl" color="red" />,
	new: <NewBadge />,
	pin: <Pin />,
	circle: <Dot size="s" color="gray" />,
	rec: <RecBadge />
};

export default function Badge({ type }: BadgeProps) {
	return <>{BadgeType[type]}</>;
}
